(function() {
  'use strict';

  angular.module('nv.components.tooltip-open').controller('TooltipOpenCtrl', tooltipCtrl);

  function tooltipCtrl() {
    this.displayBody = false;
    this.hideTipBody = () => {
      this.displayTooltip = false;
    };
    this.leaveTip = () => {
      this.displayBody = this.displayBody !== true;
    };
  }
})();
